/**
 * **Hotetec Homepage**
 *
 * @exports partnership_10016
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
       * @memberOf module:partnership_10016
       */
    partnership.getId = () => '10016';
    /**
       * @memberOf module:partnership_10016
       */
    partnership.check = function check() {
        // Check if we are in the booking engine of Hotetec hotels
        const checkRegex = /hotelesglobales|mixhotels/;
        return !!window.location.hostname.match(checkRegex);
    };
    /**
       * @memberOf module:partnership_10016
       */
    partnership.getHotelId = function getHotelId() {
        const dataLayer = window.dataLayer || {};
        const hotelId = (thn.objectGet(dataLayer, 'hotel') || thn.objectGet(dataLayer, 'Buscador_Hotel'))?.replace(/(\*|\d| )/g, '').toLowerCase();
        // For BE Hoteles Globales
        if (window.location.hostname.includes('hotelesglobales')) {
            return hotelId ? { partnership_hotel_id: hotelId } : { account_key: 'FCFBB4AC26BD19FB271DAF236C821FFC' };
        } // For BE Mix Hoteles
        return hotelId ? { partnership_hotel_id: hotelId } : { account_key: '5D7D67EBADBDC0D47F11E6155543272F' };
    };
    return partnership;
}

export { factory };
